import React from 'react'

import FormControlled from 'common/Forms/Base/FormControlled'
import RadioGroup from 'common/RadioGroup'

export default props => <FormControlled tag={RadioGroup} {...props} />
